import React from 'react'
import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Textarea } from "@chakra-ui/react";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MdApproval  as ApprovalIcon} from "react-icons/md";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { FaRegFileAlt as FileIcon } from "react-icons/fa";


type DocumentViewerProps = {
  label: string;
  path?: string | null;
  onView?: (path: string) => void;
};

const DocumentViewer = ({ label, path, onView }: DocumentViewerProps) => {
  if (!path) {
    return (
      <Flex gap="20px" align="center">
        <Text width="200px" fontWeight="bold">{label}:</Text>
        <Text color="gray.400">Not uploaded</Text>
      </Flex>
    );
  }

  return (
    <Flex gap="20px" align="center">
      <Text width="200px" fontWeight="bold">{label}:</Text>

      <Flex
        align="center"
        gap="8px"
        cursor="pointer"
        onClick={() => onView?.(path)}
        color="blue.500"
        _hover={{ textDecoration: 'underline' }}
      >
        <FileIcon />
        <Text fontSize="sm">View document</Text>
      </Flex>
    </Flex>
  );
};



export default DocumentViewer
